<template>
  <div :class="['page-wrapper', { 'tg-frame': isTGFrame }]">
    <div class="download-box">
      <!-- 顶部标题 -->
      <div v-if="!isTGFrame" class="header-title">
        <img class="logo" src="../../assets/images/entryThemeOne/logo-orange.png" />
      </div>
      <h1 class="main-title">
        <img src="../../assets/images/entryThemeOne/down-money.png" alt="" />
      </h1>
      <!-- 主内容区域 -->
      <div class="main-content u-text-center">
        <!-- 成功图标 -->
        <div class="success-icon">
          <img src="../../assets/images/entryThemeOne/down-success.png" alt="" />
        </div>

        <!-- 认证成功提示 -->
        <div class="auth-success">
          <h2>恭喜您 手机号已通过认证！</h2>
          <p>前往APP领取限时福利包</p>
        </div>

        <!-- 合规调整：移除极速通道及限定时间放款承诺。 -->
        <div class="credit-module bg-rotate">
          <div class="speed-channel">
            <div class="channel-info">
              <!-- 删除固定速度比例，仅保留速度提示和箭头标识。 -->
              <p class="speed-info">
                放款速度
                <span class="speed-icon">
                  <img src="../../assets/images/entryThemeOne/icon-up-arrow.png" alt="" />
                </span>
              </p>
            </div>
            <p class="speed-quotation">限时资格</p>
            <div class="countdown">
              <span class="countdown-number">{{ timer.h }}</span>
              <span class="countdown-separator">:</span>
              <span class="countdown-number">{{ timer.m }}</span>
              <span class="countdown-separator">:</span>
              <span class="countdown-number">{{ timer.s }}</span>
            </div>
          </div>
        </div>

        <!-- 下载按钮 -->
        <van-button class="download-btn" type="default" @click="handleDownload">
          <img
            class="download-icon"
            src="../../assets/images/entryThemeOne/down-vector.png"
            alt=""
          />
          <span>下载APP领取额度</span>
        </van-button>
        <p class="download-tips">- 平均5秒完成下载安装 -</p>
      </div>

      <!-- 温馨提示 -->
      <div class="tips-section">
        <p class="tips-text">
          温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
        </p>
      </div>

      <!-- 3步完成借款 -->
      <div class="steps-section">
        <div class="steps-title">
          <img
            class="header-line left"
            src="../../assets/images/entryThemeOne/header-line.png"
            alt=""
          />
          <!-- 合规调整：标题不再承诺审批或借款速度。 -->
          <span class="steps-title-text">申请流程</span>
          <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
        </div>
        <div class="steps-container">
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_1.png" alt="" />
            </div>
            <div class="step-text">1.填写资料</div>
          </div>
          <!-- 合规调整：第三步限定时间放款文案及对应箭头一并移除。 -->
          <div class="step-item">
            <div class="step-icon">
              <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
            </div>
            <div class="step-text">2.申请额度</div>
          </div>
          <div class="step-arrow">
            <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- 渠道 weibowallethalf / weibozhuanH5 + 非安卓：引导在浏览器中打开 -->
    <div v-show="showIosGuide" class="ios-guide-mask" @click="showIosGuide = false">
      <div class="ios-guide-pop">
        <img class="ios-guide-arrow" src="../../assets/images/icon_share.png" alt="" />
        <div class="ios-guide-text">
          <p class="ios-guide-main">
            点击右上角 <span class="ios-guide-dots">···</span> 图标，选择
            <span class="ios-guide-browser">
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="#4A90E2" />
                <ellipse
                  cx="12"
                  cy="12"
                  rx="4"
                  ry="10"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1.5"
                />
                <path
                  d="M2 12h20M4.5 7h15M4.5 17h15"
                  fill="none"
                  stroke="#fff"
                  stroke-width="1.5"
                />
              </svg>
              <b>浏览器打开</b>
            </span>
          </p>
          <p class="ios-guide-sub">若浏览器打开失败，请到应用市场搜索【闪借花】</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
import { createCountdown } from '@/utils/countdown'
import { isInTGFrame, navigateTGFrameOrSelf } from '@/utils/tgFrame'

// 指定渠道统一下载 public 目录中的审核版安装包
const FIXED_ANDROID_APK_PATH = '/app-1.0.22-1023-sjhreview-release.apk'
const GUIDE_CHANNELS = ['weibowallethalf', 'weibozhuanH5']

export default {
  name: 'DownloadApp',
  data() {
    return {
      channel: this.$route.query.source,
      brand: this.$route.query.brand,
      downAppUrl: undefined,
      countdown: null,
      timer: { h: '01', m: '00', s: '00' },
      showIosGuide: false,
    }
  },
  computed: {
    isTGFrame() {
      return isInTGFrame()
    },
    needOsDownloadGuide() {
      const channel = this.$route.query.source || this.channel
      return GUIDE_CHANNELS.indexOf(channel) !== -1
    },
    downloadTargetUrl() {
      if (this.brand === 'xiaomi') return 'https://app.xiaomi.com/detail/1500555'
      return this.downAppUrl
    },
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'download'
  },
  mounted() {
    this.getDownloadUrl()
    this.initCountdown()
    this.trackTl5ThemeOneBase('100050')
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
    this.stopCountdown()
  },
  methods: {
    initCountdown() {
      this.countdown = createCountdown({
        initialTime: 3600,
        onUpdate: (time) => {
          this.timer = time
        },
        onEnd: () => {
          console.log('倒计时结束')
        },
      })
      this.countdown.start()
    },
    stopCountdown() {
      if (this.countdown) {
        this.countdown.stop()
      }
    },
    getUa() {
      return (navigator.userAgent || '').toLowerCase()
    },
    isWeixin() {
      return this.getUa().indexOf('micromessenger') !== -1
    },
    isAndroidClient() {
      return /android/i.test(navigator.userAgent || '') || this.client === 'android'
    },
    isInAppBrowser() {
      const ua = this.getUa()
      return (
        ua.indexOf('micromessenger') !== -1 ||
        ua.indexOf('weibo') !== -1 ||
        ua.indexOf('qq/') !== -1
      )
    },
    getFixedAndroidApkUrl() {
      return `${window.location.origin}${FIXED_ANDROID_APK_PATH}`
    },
    // 下载：指定渠道安卓 → 固定 apk；内置浏览器非安卓/微信 → 引导；其余直接跳转
    handleDownload() {
      this.trackTl5ThemeOneBase('100051')

      if (this.needOsDownloadGuide && this.isAndroidClient()) {
        navigateTGFrameOrSelf(this.getFixedAndroidApkUrl())
        return
      }

      if (
        (this.needOsDownloadGuide && this.isInAppBrowser() && !this.isAndroidClient()) ||
        this.isWeixin()
      ) {
        this.showIosGuide = true
        return
      }

      navigateTGFrameOrSelf(this.downloadTargetUrl)
    },
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
    trackTl5ThemeOneBase(eventType) {
      API_Common.handleBatchTrackBase(eventType)
    },
  },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  min-height: 100vh;
}

.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/down-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;

  .credit-module {
    position: relative;
    border-radius: 0.24rem;
    margin-bottom: 0.2rem;
    background: #f9f9f9;
    padding: 0.28rem 0.2rem;
    &.bg-rotate {
      background: linear-gradient(135deg, #fff2eb 0%, #fff6f0 100%);
      border: 1px solid #ffe6d9;
    }

    .speed-channel {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.15rem 0.2rem;

      .channel-info {
        flex: 1;

        .channel-title {
          font-size: 0.26rem;
          color: #601b00;
          margin-top: 0.08rem;
          margin-bottom: 0.18rem;
          text-align: left;
        }
        .speed-info {
          display: flex;
          align-items: center;
          font-size: 0.3rem;
          font-weight: 600;
          color: #601b00;
          text-align: left;
          .speed-icon {
            margin-left: 0.08rem;
          }
        }
      }

      .speed-quotation {
        position: absolute;
        top: 0rem;
        right: 0rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #fff;
        margin: 0;
        padding: 0.08rem 0.15rem;
        background-color: #ff6410;
        border-top-right-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 0 50%);
      }

      .countdown {
        display: flex;
        align-items: center;
        margin-top: 0.46rem;
        .countdown-number {
          font-size: 0.3rem;
          font-weight: 600;
          color: #ff732a;
          background: #fff;
          padding: 0.08rem;
          border-radius: 0.08rem;
          min-width: 0.4rem;
          text-align: center;
        }

        .countdown-separator {
          font-size: 0.24rem;
          font-weight: 600;
          color: #ff6b35;
          margin: 0 0.08rem;
        }
      }
    }
  }

  // 顶部标题
  .header-title {
    padding: 0.3rem 0;

    .logo {
      width: 4rem;
      height: auto;
      margin-bottom: 0.16rem;
    }

    .title-text {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
    }
  }

  // 主内容区域
  .main-title {
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
    text-align: center;
    img {
      width: 80%;
      height: auto;
    }
    .amount {
      color: #ff5713;
    }
  }
  .main-content {
    padding: 0.5rem 0.3rem;
    background: white;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    // 成功图标
    .success-icon {
      margin-bottom: 0.4rem;
      img {
        width: 1.4rem;
        height: auto;
      }
      .icon-circle {
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    // 认证成功提示
    .auth-success {
      margin-bottom: 0.6rem;

      h2 {
        font-size: 0.36rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.16rem;
      }

      p {
        font-size: 0.28rem;
        color: #666;
      }
    }

    // 福利卡片
    .benefit-cards {
      display: flex;
      justify-content: center;
      margin-bottom: 0.6rem;
      img {
        width: 6rem;
        height: auto;
      }
    }

    // 下载按钮
    .download-btn {
      width: 100%;
      height: 1rem;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;

      .download-icon {
        width: 0.32rem;
        height: 0.32rem;
      }
      span {
        margin-left: 0.1rem;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
    }
  }

  // 温馨提示
  .tips-section {
    padding: 0.2rem;
    margin-bottom: 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;
    margin: 0.3rem 0;
    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
    }
  }

  // 流程步骤
  .process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon {
        width: 0.6rem;
        height: 0.6rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        color: white;
        font-size: 0.28rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.12rem;
      }

      .step-text {
        font-size: 0.22rem;
        color: #666;
      }
    }

    .step-arrow {
      margin: 0 0.1rem;
      color: #999;
    }
  }

  /* 3步完成借款 */
  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      .header-line {
        width: 1rem;
        height: 0.1rem;
        margin-bottom: 0.15rem;
        &.left {
          transform: rotate(180deg);
        }
      }
      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}

.tg-frame .download-box {
  background: linear-gradient(180deg, #1fbf75 0%, #1fbf75 36%, #f3f4f6 36%, #f3f4f6 100%);
  background-image: none;
  background-color: #f3f4f6;
  color: #1a2744;

  .main-content {
    background: #fff;
    box-shadow: 0 0.08rem 0.24rem rgba(31, 191, 117, 0.12);

    .auth-success {
      h2 {
        color: #1a2744;
      }

      p {
        color: #888;
      }
    }

    .credit-module {
      background: #f5fbf7;

      &.bg-rotate {
        background: linear-gradient(135deg, #edfbf3 0%, #e8f8ef 100%);
        border-color: #c8eed9;
      }

      .speed-channel {
        .channel-info {
          .channel-title {
            color: #1a2744;
          }

          .speed-info {
            color: #1a2744;
          }
        }

        .speed-quotation {
          background-color: #1fbf75;
        }

        .countdown {
          .countdown-number {
            color: #1fbf75;
          }

          .countdown-separator {
            color: #1fbf75;
          }
        }
      }
    }

    .download-btn {
      background: linear-gradient(90deg, #ff8a45 0%, #ff5c1a 100%);
      box-shadow: 0 0.12rem 0.28rem rgba(255, 92, 26, 0.28);
    }

    .download-tips {
      color: #888;
    }
  }

  .tips-section {
    background: #f0faf4;

    .tips-text {
      color: #666;
    }
  }

  .steps-section {
    background: linear-gradient(180deg, #f5fbf7 0%, #ffffff 16.39%, #ffffff 100%);
    box-shadow: 0 2px 10px rgba(31, 191, 117, 0.08);

    .steps-title {
      color: #1a2744;
    }

    .steps-container {
      .step-item {
        .step-text {
          color: #666;
        }
      }
    }
  }
}

.ios-guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.ios-guide-pop {
  position: relative;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
}

.ios-guide-arrow {
  display: block;
  width: 3.38rem;
  height: 4.8rem;
  position: absolute;
  right: 0.44rem;
  top: 0.34rem;
}

.ios-guide-text {
  position: absolute;
  top: 5.2rem;
  left: 0;
  width: 100%;
  padding: 0 0.6rem;
  text-align: center;
  box-sizing: border-box;
  color: #fff;
}

.ios-guide-main {
  margin: 0;
  font-size: 0.34rem;
  line-height: 0.52rem;
  font-weight: 500;
  color: #fff;
}

.ios-guide-dots {
  display: inline-block;
  padding: 0 0.06rem;
  font-size: 0.4rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
  vertical-align: middle;
  color: #fff;
}

.ios-guide-browser {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  color: #fff;

  svg {
    margin: 0 0.06rem;
    flex-shrink: 0;
  }

  b {
    font-weight: 600;
    color: #fff;
  }
}

.ios-guide-sub {
  margin: 0.28rem 0 0;
  font-size: 0.26rem;
  line-height: 0.4rem;
  color: rgba(255, 255, 255, 0.85);
}
</style>
